<div class="dropdown-container">
  <button class="dropdown-toggle-btn {{ buttonClass }}" [disabled]="disabled" (click)="toggleDropdown()" type="button">
    {{ label }}
    <span class="dropdown-arrow" [class.open]="isOpen">
      <app-icam-icon [iconName]="icon" iconHeight="50%" />
    </span>
  </button>

  <div class="dropdown-menu" [class.show]="isOpen">
    @for (option of options; track option) {
      <button
        class="dropdown-item"
        [disabled]="option.disabled"
        (click)="selectOption(option)"
        type="button"
        >
        {{ option.label }}
      </button>
    }
  </div>
</div>
